import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from "axios";
import { AppThunk, RootState } from '../../../store/store';
import { getRequest, apiSuccessHandler, apiErrorHandler } from '../../core/bffApiModule'
import * as CONSTANTS from '../../../constants/constants';
import * as Model from './certificationProjectSelectModel';
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";


// state初期化
const initialState: Model.CertificationProjectSelectState = {
  dataList: []
  , selectDataList: []
  , exclusionList: []
  , certificationProjectSelectRow: {
    key: ""
    , projectId: ""
    , projectName: ""
    , projectUpdateDatetime: ""
  }
  , certificationProjectCriteria: {
    branchId: ""
    , projectName: ""
    , belongCompanyId: ""
  }
  , total: 0
  , branchList_summary: []
  , modalSelectValues: []
  , modalConfirmValues: []
  , selectProjectRow: []
  , currentPage: 1
  , firstFlag: true
};

export const CertificationProjectSelectSlice = createSlice({
  name: 'projectSelect',
  initialState,
  reducers: {
    initState: (State) => {
      State.certificationProjectSelectRow = initialState.certificationProjectSelectRow;
    },
    getDataListOfProjectSelect: (state, action: PayloadAction<Model.getProjectList.Response>) => {

      let projectList: Array<Model.ProjectRow> = [];

      action.payload.projectList.forEach((apiDataRow: Model.ProjectRow) => {

        const rec: Model.ProjectRow = {
          key: apiDataRow.projectId,
          // プロジェクトID
          projectId: apiDataRow.projectId,
          // プロジェクト名称
          projectName: apiDataRow.projectName,
          // プロジェクト更新日時
          projectUpdateDatetime: apiDataRow.projectUpdateDatetime,
        };
        if (!state.selectDataList.map(val => val.projectId).includes(rec.projectId)) {
          projectList.push(rec);
        }
      });
      state.dataList = projectList;
      state.modalConfirmValues = state.selectDataList;
      state.modalSelectValues = [];
      state.total = projectList.length;
    },
    getDataListOfProjectSelectFirst: (state, action: PayloadAction<Model.getProjectList.Response>) => {

      let projectList: Array<Model.ProjectRow> = [];
      let selectProjectList: Array<Model.ProjectRow> = state.selectProjectRow;

      action.payload.projectList.forEach((apiDataRow: Model.ProjectRow) => {

        const rec: Model.ProjectRow = {
          key: apiDataRow.projectId,
          // プロジェクトID
          projectId: apiDataRow.projectId,
          // プロジェクト名称
          projectName: apiDataRow.projectName,
          // プロジェクト更新日時
          projectUpdateDatetime: "",
        };
        if (!state.selectProjectRow.map(val => val.projectId).includes(rec.projectId)) {
          projectList.push(rec);
        }
      });
      state.dataList = projectList;
      state.selectDataList = selectProjectList;
      state.modalConfirmValues = selectProjectList;
      state.total = projectList.length;
      state.selectDataList.sort((a, b) => {
        return a.projectName > b.projectName ? 1 : -1
      })
    },
    setCriteria: (state, action: PayloadAction<Model.CertificationProjectCriteria>) => {
      let criteria: Model.CertificationProjectCriteria = {
        branchId: action.payload.branchId,
        projectName: action.payload.projectName,
        belongCompanyId: action.payload.belongCompanyId
      }
      state.certificationProjectCriteria = criteria;
    },
    setBranchList_summary: (state, action: PayloadAction<Model.getProjectList.Response>) => {

      let branchList: Array<Model.branch> = [];
      action.payload.branchList.forEach((apiDataRow: Model.branch) => {
        const branch: Model.branch = {
          branchId: apiDataRow.branchId
          , branchName: apiDataRow.branchName
        };
        branchList.push(branch);
      });
      state.branchList_summary = branchList;
    },
    initModalSelectValue: (state, action: PayloadAction<string[]>) => {
      state.modalSelectValues = initialState.modalSelectValues;
      state.modalConfirmValues = initialState.modalConfirmValues;
      state.selectDataList = initialState.selectDataList;
      state.selectProjectRow = initialState.selectProjectRow;
      const projectIdList = action.payload[0].length > 0 ? action.payload[0].split(",") : [];
      const projectNameList = action.payload[0].length > 0 ? action.payload[1].split(",") : [];
      const projectUpdateDatetimeList = action.payload[0].length > 0 ? action.payload[2].split(",") : [];
      state.selectProjectRow = projectIdList.map((projectId,idx) => {
        let tempProjectRow: Model.ProjectRow = {
          key: projectId,
          projectId: projectId,
          projectName: "",
          projectUpdateDatetime: ""
        };
        tempProjectRow.key = projectId;
        tempProjectRow.projectId = projectId;
        tempProjectRow.projectName = projectNameList[idx];
        tempProjectRow.projectUpdateDatetime = projectUpdateDatetimeList[idx];
        return tempProjectRow;
      })
    },
    reflectModalSelectValue: (state, action: PayloadAction<Model.CertificationProjectSelectRow>) => {
      // 選択した値が配列になければ追加、配列にすでにあれば削除
      let isInclude = false;
      let deleteIndex = 0;
      state.modalSelectValues.some((modalSelectValue: Model.CertificationProjectSelectRow) => {
        if (action.payload.projectId === modalSelectValue.projectId) {
          isInclude = true;
          return true;
        }
        deleteIndex++;
      })
      if (isInclude) {
        state.modalSelectValues.splice(deleteIndex, 1);
      } else {
        state.modalSelectValues.push(action.payload);
      }
    },
    reflectModalConfirmValue: (state, action: PayloadAction<Model.CertificationProjectSelectRow>) => {
      // 選択した値が配列になければ追加、配列にすでにあれば削除
      let isInclude = false;
      let deleteIndex = 0;
      state.modalConfirmValues.some((modalConfirmValues: Model.CertificationProjectSelectRow) => {
        if (action.payload.projectId === modalConfirmValues.projectId) {
          isInclude = true;
          return true;
        }
        deleteIndex++;
      })
      if (isInclude) {
        state.modalConfirmValues.splice(deleteIndex, 1);
      } else {
        state.modalConfirmValues.push(action.payload);
      }
    },
    addSelectDataList: (state) => {
      state.modalSelectValues.forEach(val => {
        if (!state.selectDataList.find(selectData => selectData.projectId == val.projectId)) {
          state.selectDataList.push(val);
          state.modalConfirmValues.push(val);
        }
        state.dataList = state.dataList.filter(data => data.projectId != val.projectId)
      })
      state.selectDataList.sort((a, b) => {
        return a.projectName > b.projectName ? 1 : -1
      })
      state.total = state.dataList.length;
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },

    initCriteria: (state, action: PayloadAction<string>) => {
      let criteria: Model.CertificationProjectCriteria = {
        branchId: initialState.certificationProjectCriteria.branchId,
        projectName: initialState.certificationProjectCriteria.projectName,
        belongCompanyId: action.payload
      }
      state.certificationProjectCriteria = criteria;
    },
    setFirstFlag: (state, action: PayloadAction<boolean>) => {
      state.firstFlag = action.payload;
    }
  }
});

export const {
  initState
  , getDataListOfProjectSelect
  , getDataListOfProjectSelectFirst
  , setCriteria
  , setCurrentPage
  , reflectModalSelectValue
  , reflectModalConfirmValue
  , addSelectDataList
  , setBranchList_summary
  , initModalSelectValue
  , initCriteria
  , setFirstFlag
} = CertificationProjectSelectSlice.actions;

export const getDataListAsync = (ProjectCriteria: Model.getProjectList.Request, firstFlag: boolean): AppThunk => async dispatch => {

  try {
    // GET-APIを呼び出します。
    const response = await getRequest(CONSTANTS.URL_CMN_PRIME_PROJECTS_ALL, {
      params: ProjectCriteria
    });
    // 結果をstateに設定します。
    if (firstFlag) {
      dispatch(getDataListOfProjectSelectFirst(response.data.data));
    } else {
      dispatch(getDataListOfProjectSelect(response.data.data));
    }
    dispatch(setBranchList_summary(response.data.data));
    // 共通成功時処理を呼び出します。
    dispatch(apiSuccessHandler(response, CONSTANTS.REQUEST_METHOD_GET));
  } catch (error :any) {
    // 共通エラー時処理を呼び出します。
    dispatch(apiErrorHandler(error.response, CONSTANTS.REQUEST_METHOD_GET));
  }
};

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const storedDataList = (state: RootState) => state.certificationProjectSelect.dataList;
export const storedSelectDataList = (state: RootState) => state.certificationProjectSelect.selectDataList;
export const storedDataRow = (state: RootState) => state.certificationProjectSelect.certificationProjectSelectRow;
export const storedDataCriteria = (state: RootState) => state.certificationProjectSelect.certificationProjectCriteria;
export const storedDataTotal = (state: RootState) => state.certificationProjectSelect.total;
export const storedBranchList_summary = (state: RootState) => state.certificationProjectSelect.branchList_summary;
export const storedModalSelectValues = (state: RootState) => state.certificationProjectSelect.modalSelectValues;
export const storedModalConfirmValues = (state: RootState) => state.certificationProjectSelect.modalConfirmValues;
export const storedDataCurrentPage = (state: RootState) => state.projectSelect.currentPage;
export const storedFirstFlag = (state: RootState) => state.certificationProjectSelect.firstFlag;

export default CertificationProjectSelectSlice.reducer;
